import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';

@Component({
  selector: 'lowy-file-download-confirm',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <span class="link" (click)="modal.close()"><i class="material-icons">keyboard_backspace</i>back</span>
      <div class="headline">Are You Sure?</div>
      <div class="subheading">
        The download you are about to run will be {{fileSize}}. Would you like to continue?
      </div>
      <div class="row">
        <div class="col-2">
          <button mat-button class="lowy-btn-std" (click)="submit()">download</button>
        </div>
      </div>
    </div>
  </lowy-modal>
  `
})
export class FileDownloadModalComponent {

  @ViewChild('modal') modal: ModalComponent;
  @Input('fileSize') fileSize: string;

  @Output() download: EventEmitter<any>;

  constructor() {
    this.download = new EventEmitter();
  }

  public open() {
    this.modal.open();
  }

  public submit() {
    this.download.emit();
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/data/file-download-confirm-modal.component.ts